import 'babel-polyfill'

import {without, throttle, debounce} from 'lodash'
import 'reframe.js/dist/jquery.reframe.min'
import whatInput from 'what-input'

import './selects'
import './content'
import './load-more'
import './front-page'
import './animal-services'
import './header'
import './jaotama'
import './modals'
import './people-tabs'
import './animateUpNumbers'
import './carousels'
import './program-strip'
import './newsletter'
import './ad-tracking'

import './gform-choice-tooltips'
import './gform-confirmation-scroll'


import { Fancybox } from "@fancyapps/ui/dist/fancybox/fancybox.esm.js";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

jQuery('.content iframe').reframe()

jQuery(document).on('mousedown', '.ginput_container_date input.gform-datepicker', function (e) {
    const $button = jQuery(this).closest('.ginput_container_date').find('.gform-datepicker-toggle')

    if (!$button.length || $button.attr('aria-expanded') === 'true') {
        return
    }

    e.preventDefault()
    $button.trigger('click')
    jQuery(this).trigger('focus')
})

jQuery(document).ready(function () {

    Fancybox.bind('[data-fancybox]', {
        mainClass: 'gallery-overlay',
        commonCaption: true,
        idle: false,
        closeButton: false,
        Toolbar: {
            display: {
                left: ['infobar'],
                middle: [],
                right: ['prev', 'next', 'close'],
            },
            parentEl: (toolbar) => toolbar.instance.footer,
        },
        Thumbs: {
            type: 'classic',
            showOnStart: true,
            key: false,
        },
        Carousel: {
            Navigation: false,
        },
    });

});
